import { render, staticRenderFns } from "./BanHistory.vue?vue&type=template&id=78ac1f61"
import script from "./BanHistory.vue?vue&type=script&lang=js"
export * from "./BanHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports